import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataTableDirective } from '../../../../shared/directives/data-table.directive';
import { ColumnConfig } from '../../../../shared/models/column-config.model';
import { Audit } from '../../models/audit.model';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../../shared/services/page-state-manager.service';
import { TitleService } from '../../../../shared/services/title.service';
import { AuditService } from '../../services/audit.service';

@Component({
  selector: 'app-audit-log',
  standalone: false,
  templateUrl: './audit-log.component.html',
})
export class AuditLogComponent extends DataTableDirective<Audit> implements OnInit, OnDestroy {

  override modelName: string = 'Audit Log';
  override columns: ColumnConfig[] = [];

  constructor(   
    private auditService: AuditService,     
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      auditService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

  override ngOnInit(): void {
    this.columns = [
      { name: 'userName', label: 'User', inputType: 'none' },
      { name: 'action', label: 'Action', inputType: 'none' },
      { name: 'tableName', label: 'Table', inputType: 'none' },
      { name: 'createdAt', label: 'Date', inputType: 'date' },      
      { name: 'id', label: 'Audit Items', inputType: 'link', linkRoute: ['/admin/audit-log/',':param','audit-items'] },
    ]
    super.ngOnInit();
  }

}
